import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

export function useArrivalToast(groups) {
  const known = useRef(null);
  useEffect(() => {
    if (!groups) { return; }
    const novos = groups.filter((g) => g.novo);
    if (known.current) {
      novos.filter((g) => !known.current.has(g.pid)).forEach((g) => toast.success(`Novo processo na tua gestão · ${g.short}`, { description: g.consultant ? `Passado por ${g.consultant}` : undefined }));
    }
    known.current = new Set(novos.map((g) => g.pid));
  }, [groups]);
}

export function Arrivals({ groups, onOpen }) {
  const novos = groups.filter((g) => g.novo);
  if (!novos.length) return null;
  return (
    <div className="rounded-2xl border border-emerald-200 bg-emerald-50/70 px-4 py-3" data-testid="gp-arrivals">
      <h2 className="flex items-center gap-2 text-lg font-semibold text-emerald-800"><Sparkles size={18} />
        {novos.length === 1 ? "Chegou um processo novo" : `Chegaram ${novos.length} processos novos`}</h2>
      {novos.map((g) => (
        <div key={g.pid} className="flex flex-wrap items-center gap-x-3 gap-y-1 py-2" data-testid={`gp-arrival-${g.pid}`}>
          <span className="flex-1 min-w-0 text-[15px] text-slate-900"><b>{g.short}</b>{g.consultant ? ` · de ${g.consultant}` : ""} · {g.items[0].title}</span>
          <button onClick={() => onOpen(g.items[0])} className="shrink-0 h-9 px-4 rounded-xl bg-emerald-600 text-white text-sm font-semibold hover:bg-emerald-700 transition-colors" data-testid={`gp-arrival-open-${g.pid}`}>Abrir</button>
        </div>
      ))}
    </div>
  );
}
